// components/CanonicalHead.js
"use client";
import { usePathname } from "@/src/hooks/usePathname";
import { Locale } from "@utils/i18n.locale";
import { locales } from "@utils/i18n";
import { SITEMAP_LANGUAGES } from "@config/sitemapLocales";

const SITE_URL = process.env.NEXT_PUBLIC_SITE_UR || "https://www.edwealth.ai";

export default function CanonicalAndAlternateHead() {
  const purePath = usePathname(false);
  const purePathWithLocale = usePathname(true);

  // 提取纯路径（去掉语言前缀）
  const segments = purePathWithLocale.split("/").filter(Boolean);
  const firstSegment = segments[0] || "";
  const isLocaleInPath = locales.includes(firstSegment as Locale);

  // 当前语言
  const currentLocale = isLocaleInPath ? firstSegment : "en";

  // 生成各语言 URL 的统一函数
  const getLocaleUrl = (locale: string) => {
    return locale === "en"
      ? `${SITE_URL}${purePath}` // en: /app/crypto
      : `${SITE_URL}/${locale}${purePath}`; // zh: /zh/app/crypto
  };

  return (
    <>
      {/* Canonical: 指向当前语言的规范 URL */}
      <link rel="canonical" href={getLocaleUrl(currentLocale)} />

      {/* x-default: 始终指向英文版本 */}
      <link rel="alternate" hrefLang="x-default" href={getLocaleUrl("en")} />

      {/* Sitemap 收录语言：en、zh-tw */}
      {SITEMAP_LANGUAGES.map((locale) => (
        <link
          key={locale}
          rel="alternate"
          hrefLang={locale}
          href={getLocaleUrl(locale)}
        />
      ))}
    </>
  );
}
